import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "5th Pair Option")
  ])
], -1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "form-horizontal" }
const _hoisted_4 = /*#__PURE__*/_createVNode("option", { value: "GC" }, "Product Rewards", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("option", { value: "TV" }, "PGI Rewards", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Transaction History")
  ])
], -1)
const _hoisted_7 = { class: "card-body py-3" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Date"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Reference"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-300px" }, "Description"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px rounded-end" }, "Amount")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    (_ctx.isAllowedFifthPairOption)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: [_ctx.widgetClasses, "card"]
        }, [
          _hoisted_1,
          _createVNode("div", _hoisted_2, [
            _createVNode("form", _hoisted_3, [
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pr_5th = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveFifthPairOptionFN())),
                class: "form-control m-l-39 dashboardFontStyle",
                style: {"width":"400px"}
              }, [
                _hoisted_4,
                _hoisted_5
              ], 544), [
                [_vModelSelect, _ctx.pr_5th]
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("table", _hoisted_9, [
            _hoisted_10,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, "   " + _toDisplayString(item.transactionID), 1),
                  _createVNode("td", null, _toDisplayString(item.txndte), 1),
                  _createVNode("td", null, _toDisplayString(item.rusid), 1),
                  _createVNode("td", null, _toDisplayString(item.transactiondesc), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.txnamount)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}